import { isAfter } from 'date-fns';
import { PlannedActivity } from '../../../api/activitiesApi/interfaces';

export const getActivityDateType = (
  plannedActivity: PlannedActivity
): 'exact' | 'range' | null => {
  if (plannedActivity.startTime && plannedActivity.endTime) {
    return 'range';
  }

  if (plannedActivity.startTime) {
    return 'exact';
  }

  return null;
};

export const getPlannedActivityDueDate = (
  plannedActivity: PlannedActivity
): Date => {
  const dateType = getActivityDateType(plannedActivity);
  const date = new Date(plannedActivity.performAt);

  date.setSeconds(0);
  date.setMilliseconds(0);

  if (dateType === 'exact' && plannedActivity.startTime) {
    const [hour, minute] = plannedActivity.startTime.split(':').map(Number);

    date.setHours(hour);
    date.setMinutes(minute);
  } else if (dateType === 'range' && plannedActivity.endTime) {
    const [hour, minute] = plannedActivity.endTime.split(':').map(Number);

    date.setHours(hour);
    date.setMinutes(minute);
  } else {
    date.setHours(23);
    date.setMinutes(59);
  }

  return date;
};

export const isPlannedActivityOverdue = (
  plannedActivity: PlannedActivity
): boolean => {
  const overdueDate = getPlannedActivityDueDate(plannedActivity);
  const now = new Date();

  now.setSeconds(0);
  now.setMilliseconds(0);

  return isAfter(now, overdueDate);
};
